module.exports = __webpack_public_path__ + "img/bg_player.449f4665.png";